export const ReferenceTableCode = {
    zeroone: '1',
    zerotwo: '2',
    zerofive: '3',
    one: '4',
} as const;